import type { MessengerPosition } from '@widgets/messenger/types'

const MESSENGER_POSITION_MESSAGE_TYPE = 'textmagicMessengerPosition' as const

interface MessengerPositionMessage {
  type: typeof MESSENGER_POSITION_MESSAGE_TYPE
  payload: MessengerPosition
}

const isMessengerPositionMessage = (data: any): data is MessengerPositionMessage => {
  return data?.type === MESSENGER_POSITION_MESSAGE_TYPE
}

export const sendMessengerPositionMessage = (position: MessengerPosition) => {
  const message = {
    type: MESSENGER_POSITION_MESSAGE_TYPE,
    payload: position,
  } satisfies MessengerPositionMessage

  window.parent.postMessage(message, '*')
}

export const subscribeOnMessengerPositionMessages = (callback: (payload: MessengerPosition) => void) => {
  const listener = ({ data }: MessageEvent) => {
    if (isMessengerPositionMessage(data)) {
      callback(data.payload)
    }
  }
  window.addEventListener('message', listener)
  return listener
}

export const unsubscribeFromMessengerPositionMessages = (listener: (e: MessageEvent) => void) =>
  window.removeEventListener('message', listener)
